module.exports = __webpack_public_path__ + "static/media/2.0fea8f00.jpeg";